import styled from 'styled-components';
import WithDirection from "../../../../config/withDirection";

const StyleWrapper = styled.div`    
    .summary-title { margin-bottom: 24px; }

    .grid-container {
        display: grid;
        grid-template-columns: 33% 33% 33%;
        grid-column-gap: 8px;
        grid-row-gap: 3px;
    }

    @media screen and (max-width: 767px) {
        .grid-container { grid-template-columns: 100%; }
        
        .grid-container > *:nth-child(4) { grid-row: 2; }
        .grid-container > *:nth-child(7) { grid-row: 3; }

        .grid-container > *:nth-child(5) { grid-row: 5; }
        .grid-container > *:nth-child(8) { grid-row: 6; }

        .grid-container > *:nth-child(6) { grid-row: 8; }
        .grid-container > *:nth-child(9) { grid-row: 9; }
    }
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/GridAppName/Wrapper.js